import { useAppSelector } from "app/hooks";
import { selectToken } from "features/auth/AuthSlice";
import {
  useGetCommentListLoginQuery,
  useGetCommentListPublicQuery,
  useGetQAListPublicQuery,
  useGetReviewListPublicQuery,
  usePostCommentLoginMutation,
  usePostCommentPublicMutation,
  usePostQALoginMutation,
  usePostQAPublicMutation,
  usePostReviewLoginMutation,
  usePostReviewPublicMutation,
} from "features/comment/service/comment.service";
import {
  CommentCollectionJson,
  TypeList,
} from "features/comment/types/comment.type";
import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { useEffect, useState } from "react";
import { EndPoint } from "common/types/Api";
type Props = {
  type: TypeList;
};

const usePostCommentEndpoint = ({ type }: Props) => {
  const token = localStorage.getItem("MAIN:token");

  // api  login
  const [addCommentLogin, addCommentLoginResult] =
    usePostCommentLoginMutation();
  //
  const [addQALogin, addQALoginResult] = usePostQALoginMutation();
  //
  const [addReviewLogin, addReviewLoginResult] = usePostReviewLoginMutation();
  ////////////////////////////

  // api public
  const [addCommentPublic, addCommentPublicResult] =
    usePostCommentPublicMutation();
  //
  const [addQAPublic, addQAPublicResult] = usePostQAPublicMutation();
  //
  const [addReviewPublic, addReviewPublicResult] =
    usePostReviewPublicMutation();
  ///////////////////////////

  if (token) {
    if (type === "comment") {
      return {
        add: addCommentLogin,
        addResult: addCommentLoginResult,
      };
    } else if (type === "qa") {
      return {
        add: addQALogin,
        addResult: addQALoginResult,
      };
    } else {
      return {
        add: addReviewLogin,
        addResult: addReviewLoginResult,
      };
    }
    // return {
    //   comment: {

    //   },
    //   review: {

    //   },
    //   qa: { addQA: addQALogin, addQAResult: addQALoginResult },
    // };
  } else {
    if (type === "comment") {
      return {
        add: addCommentPublic,
        addResult: addCommentPublicResult,
      };
    } else if (type === "qa") {
      return {
        add: addQAPublic,
        addResult: addQAPublicResult,
      };
    } else {
      return {
        add: addReviewPublic,
        addResult: addReviewPublicResult,
      };
    }
    // return {
    //   comment: {
    //     addComment: addCommentPublic,
    //     addCommentResult: addCommentPublicResult,
    //   },
    //   review: {
    //     addReview: addReviewPublic,
    //     addReviewResult: addReviewPublicResult,
    //   },
    //   qa: {
    //     addQA: addQA,
    //     addQAResult: addQAResult,
    //   },
    // };
  }
};
export default usePostCommentEndpoint;
